import { AmbientLight, MathUtils, Scene, Vector3 } from "three";
import { CameraController } from "../../../componets3D/CameraController";
import { MouseEvents } from "../../../componets3D/MouseEvents";
import { CharcterOxxo } from "../../objects/CharacterOxxo";
import { MapOxxoTeam2TopicOne } from "./subTopicOne/MapOxxoTeam2TopicOne";
import ObserverEmitter, { EVENTS } from "../../../../emitter/Observer";
import { CoffeeMachineFilling } from "./subtopicTwo/CoffeeMachineFilling";
import { audiosAssets } from "../../../../assets/audio";

export class SceneTeam2TopicTwo extends Scene {
	constructor(loadingManager, container, render, character = new CharcterOxxo(), enviro) {
		super();
		this.characterSelected = character;
		this.environment = enviro;
		this.camera = new CameraController();
		this.loadingManager = loadingManager;
		this.mouseEvents = new MouseEvents(container, render, this.camera, this);
		this.stepActivity = 0;
		this.light()
		this.create();
		this.renderAnimations();
		this.observerListeners();
	}

	create() {
		this.mapmenu = new MapOxxoTeam2TopicOne(this.loadingManager);
		this.add(this.mapmenu);
		this.add(this.characterSelected);
		this.coffeeMachineFilling = new CoffeeMachineFilling(this.camera, this.loadingManager);
	}

	light() {
		this.ambient = new AmbientLight();
		this.ambient.color.set(0xffffff);
		this.ambient.intensity = 1;
		this.add(this.ambient);
	}

	SceneInitialState() {
		this.mouseEvents.disposeInteractions();
	}

	sceneActivityOneState() {
		this.characterSelected.position.set(-5.9111, -1.8, -4);
		this.characterSelected.rotation.set(0, 0.9998, 0);
		this.characterSelected.visible = true;
		this.characterSelected.onAnimateSaludo();
		this.stepActivity = 1;
	}

	sceneActivityTwoState() {
		this.stepActivity = 2;
		this.characterSelected.position.set(-5.9111, -1.8, -4);
		this.characterSelected.rotation.set(0, 0.9998, 0);
		this.characterSelected.visible = true;
		this.characterSelected.onAnimateSaludo();
		this.coffeeMachineFilling.clearAnimation()
		this.coffeeMachineFilling.hiddemObjects();
		this.add(this.coffeeMachineFilling);
		this.mouseEvents.disposeInteractions();
		this.mouseEvents.objectsToValue = [
			this.coffeeMachineFilling.Americano,
			this.coffeeMachineFilling.Capuchino,
			this.coffeeMachineFilling.Kobalto,
		];
		this.mouseListenersEnableMovementActivityOne();
	}

	sceneActivitySevenState() {
		this.characterSelected.position.set(-5.9111, -1.8, -4);
		this.characterSelected.rotation.set(0, 0.9998, 0);
		this.characterSelected.visible = true;
		this.characterSelected.onAnimateSaludo();
		this.stepActivity = 7;
	}

	sceneActivityEightState() {
		this.characterSelected.position.set(-5.9111, -1.8, -4);
		this.characterSelected.rotation.set(0, 0.9998, 0);
		this.characterSelected.visible = true;
		this.characterSelected.onAnimateSaludo();
		this.stepActivity = 8;
		this.mapmenu.onAnimateTwo()

		ObserverEmitter.on(EVENTS.team2.subtopicTwo.activityEight.moveTable, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-8.9656, 0.6737, -5.1436), 1, new Vector3(-11.068, -0.271, -6.967), () => {
			})
		});

		ObserverEmitter.on(EVENTS.team2.subtopicTwo.activityEight.checkMachine, (step = "") => {
			this.mouseEvents.disposeInteractions();
			this.mouseEvents.objectsToValue = []

			switch (step) {
				case "Yelox":
					this.mapmenu.onAnimateTwo(this.mapmenu.Yelox)
					this.mouseEvents.objectsToValue = [this.mapmenu.Yelox]
					break;
				case "Cafetera_Krea":
					this.mapmenu.onAnimateTwo(this.mapmenu.Cafetera_Krea)
					this.mouseEvents.objectsToValue = [this.mapmenu.Cafetera_Krea]
					break;
				case "Cafetera_2":
					this.mapmenu.onAnimateTwo(this.mapmenu.Cafetera_2)
					this.mouseEvents.objectsToValue = [this.mapmenu.Cafetera_2]
					break;
				case "Cafetera_1":
					this.mapmenu.onAnimateTwo(this.mapmenu.Cafetera_1)
					this.mouseEvents.objectsToValue = [this.mapmenu.Cafetera_1]
					break;
				case "Cafetera_3":
					this.mapmenu.onAnimateTwo(this.mapmenu.Cafetera_3)
					this.mouseEvents.objectsToValue = [this.mapmenu.Cafetera_3]
					break;
				default:
					this.mapmenu.onAnimateTwo()
					break;
			}

			this.mouseListenersEnableMovementActivityOne();
		});
	}

	activeAudio() {
		ObserverEmitter.emit(EVENTS.audioInitByTopic)
	}

	ActivitiSelected(activity) {
		switch (activity) {
			case 0:
				this.camera.moveCameraToPoint(new Vector3(-8.8658, -0.1739, 1.7731), 1, new Vector3(-7.758, -0.494, 0.201), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = true;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = true;
					this.characterSelected.onAnimateSaludo();
					this.activeAudio()
				});
				break;
			case 1:
				this.camera.moveCameraToPoint(new Vector3(-4.2751, -1.3041, -3.0297), 1, new Vector3(-6.81, -1.86, -4.409), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					// this.camera.control.maxAzimuthAngle = Infinity;
					// this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.maxAzimuthAngle = 1.142;
					this.camera.control.minAzimuthAngle = -0.579;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.sceneActivityOneState();
					this.activeAudio()
				});
				break;
			case 2:
				this.camera.moveCameraToPoint(new Vector3(-4.2751, -1.3041, -3.0297), 1, new Vector3(-6.81, -1.86, -4.409), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = 1.142;
					this.camera.control.minAzimuthAngle = -0.579;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.sceneActivityTwoState();
					this.activeAudio()
				});
				break;
			case 7:
				this.camera.moveCameraToPoint(new Vector3(-4.2751, -1.3041, -3.0297), 1, new Vector3(-6.81, -1.86, -4.409), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					// this.camera.control.maxAzimuthAngle = Infinity;
					// this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.maxAzimuthAngle = 1.142;
					this.camera.control.minAzimuthAngle = -0.579;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.sceneActivitySevenState();
					this.activeAudio()
				});
				break;
			case 8:
				this.camera.moveCameraToPoint(new Vector3(-4.2751, -1.3041, -3.0297), 1, new Vector3(-6.81, -1.86, -4.409), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					// this.camera.control.maxAzimuthAngle = Infinity;
					// this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.maxAzimuthAngle = 1.142;
					this.camera.control.minAzimuthAngle = -0.579;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enableRotate = false;
					this.camera.control.enablePan = false;

					this.sceneActivityEightState();
					this.activeAudio()
				});
				break;
			default:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.ennablePan = false;

				});
				break;
		}
	}

	mouseListenersEnableMovementActivityOne() {
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.completeNavigation)
				const name = interactions[0].object.name;
				ObserverEmitter.emit(EVENTS.team2.subtopicTwo.clickedRayCaster, name);
			}
		});
	}

	observerListeners() {
		ObserverEmitter.on(EVENTS.team2.subtopicTwo.stepUseRayCaster, (step) => {
			if (this.stepActivity === 2) {
				const objectSelect = this.coffeeMachineFilling[step];
				if (objectSelect !== undefined) {
					this.coffeeMachineFilling.onAnimate(objectSelect, this.stepObject);
				}
			}
			this.stepObject = step;
		});

		ObserverEmitter.on(EVENTS.team2.subtopicTwo.activityTwo.moveCashRegister, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-13.1125, -0.4767, 1.391), 1, new Vector3(-11.712, -1.013, 2.946), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.enableRotate = true;
				this.camera.control.maxAzimuthAngle = 3.878;
				this.camera.control.minAzimuthAngle = 3.568;
				this.camera.control.minDistance = 1;
				this.camera.control.maxDistance = 3;
				this.camera.control.enablePan = true;

				this.coffeeMachineFilling.onMoveObjectTable();
				this.coffeeMachineFilling.onVisibleCoffes();
			});
		});
	}

	renderAnimations(delta) {
		this.coffeeMachineFilling.renderAnimations(delta);
	}
}
